import Component from './Component'

export default class PairList extends Component {

	static _type = 'PairList'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil

		// Create bound event handlers and register them
		this.updateListener = PairList._updateListener.bind(this)
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		// Initialize draggable
		$(this.base).find('.pairlist-item').draggable({
			revert: true,
			revertDuration: 0,
			containment: this.base
		})
		$(this.base).find('.pairlist-slot').droppable({
			classes: {
  				'ui-droppable-active': '',
  				'ui-droppable-hover': 'bg-light'
			},
			drop: function(event, ui) {
				$(event.target).find('.pairlist-item').appendTo($(this.base).find('.pairlist-initial'))
				ui.draggable.appendTo(event.target)

				// Compile data
				let slots = $(this.base).find('.pairlist-slot')
				let value = []
				for (let slot of slots) {
					let item = $(slot).find('.pairlist-item')
					if (item.length > 0) {
						value.push($(item).attr('value'))
					} else {
						value.push(null)
					}
				}

				// Send data to the record
				this.form.data[this.params.name] = value
			}.bind(this)
		})

		$(this.base).disableSelection()
	}

	static _updateListener (value, errors) {

		if (Array.isArray(value)) {
			let slots = $(this.base).find('.pairlist-slot')
			for (let i = 0; i < value.length; i++) {
				let option_id = value[i]
				$(this.base).find(`.pairlist-item[value="${option_id}"]`).appendTo(slots[i])
			}
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			//$(this.input_els).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			//$(this.input_els).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
